// @ vendors
const Immutable = require('immutable');
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');
const { getDateWithOffset } = require('utilities/dateHelper/dateHelper');

const initialState = Immutable.fromJS({
    simulation: {
        amount: 0,
        clientRiskProfile: null,
        currency: 'EUR',
        endDate: null,
        hasRecurringTransfer: false,
        initialContribution: null,
        id: null,
        maxTypeOfProduct: null,
        name: '',
        recurringTransfer: null,
        selectedPortfolio: null,
        type: '',
    },
    isFetching: false,
    isSaving: false,
    saveSuccess: false,
    success: false,
    error: false,
});

const getValidEndOfDate = endDate => {
    if (!endDate || new Date(endDate) < getDateWithOffset(new Date(), { years: 1 })) {
        return null;
    }

    return endDate;
};

const RASimulation = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RA_MANAGEMENT_PLAN_RESET:
            return initialState;
        case actionTypes.RA_SIMULATION_REQUEST:
            return state.merge({
                isFetching: true,
                success: false,
                error: false,
            });
        case actionTypes.RA_SIMULATION_REQUEST_FAILURE:
            return state.merge({
                isFetching: false,
                success: true,
                error: false,
                simulation: initialState.get('simulation'),
            });
        case actionTypes.RA_SIMULATION_REQUEST_SUCCESS:
            return state.merge({
                isFetching: false,
                success: true,
                error: false,
                simulation: {
                    amount: action.payload.amount,
                    clientRiskProfile: action.payload.clientRiskProfile,
                    currency: action.payload.currency,
                    endDate: getValidEndOfDate(action.payload.endDate),
                    hasRecurringTransfer: action.payload.hasRecurringTransfer,
                    initialContribution: action.payload.initialContribution,
                    id: action.payload.id,
                    maxTypeOfProduct: action.payload.maxTypeOfProduct,
                    name: action.payload.name,
                    recurringTransfer: action.payload.recurringTransfer,
                    selectedPortfolio: action.payload.selectedPortfolio,
                    type: action.payload.type && action.payload.type.toLowerCase(),
                },
            });
        case actionTypes.RA_SIMULATION_SAVE:
            return state.merge({
                isSaving: true,
                saveSuccess: false,
                error: false,
            });
        case actionTypes.RA_SIMULATION_SAVE_SUCCESS:
            return state.merge({
                isSaving: false,
                saveSuccess: true,
                error: false,
            });
        case actionTypes.RA_SIMULATION_SAVE_FAILURE:
            return state.merge({
                isSaving: false,
                saveSuccess: false,
                error: true,
            });
        case actionTypes.RA_SIMULATION_UPDATE_SIMULATION:
            return state.mergeDeepIn(['simulation'], action.payload);
        default:
            return state;
    }
};

module.exports = RASimulation;
